document.addEventListener("DOMContentLoaded",()=>{

    const tabs=document.querySelectorAll(".ymal-tab");
    const products=document.querySelectorAll(".ymal-products");

    tabs.forEach(tab=>{

        tab.addEventListener("click",()=>{

            tabs.forEach(t=>t.classList.remove("active"));

            products.forEach(p=>p.classList.add("hidden"));

            tab.classList.add("active");

            document
            .getElementById(tab.dataset.tab)
            .classList.remove("hidden");

        });

    });

});